export const team = [
  {
    name: { en: "Hani Hijazi", ar: "هاني حجازي" },
    role: { en: "Director & Creative Lead", ar: "المخرج ومدير إبداعي" },
    image: "/team/hani-hijazi.jpg",
    lead: true,
  },
  {
    name: { en: "Marwan Al-Mutairi", ar: "مروان المطيري" },
    role: { en: "Administrator", ar: "إداري" },
    image: "/team/marwan.jpeg",
  },
  {
    name: { en: "Musaid Al-Saqr", ar: "مساعد الصقر" },
    role: { en: "Technical Director", ar: "المدير التقني" },
    image: "/team/musaid.jpg",
  },
  {
    name: { en: "Mohammed Ifrangi", ar: "محمد إفرنجي" },
    role: { en: "Production Manager", ar: "مدير الإنتاج" },
    image: "/team/mohammed-ifrangi.jpg",
  },
  {
    name: { en: "Mohamed Suleiman", ar: "محمد سليمان" },
    role: { en: "Director of Photography", ar: "مدير التصوير" },
    image: "/team/mohamed-suleiman.jpg",
  },
  {
    name: { en: "Sameh Fares", ar: "سامح فارس" },
    role: { en: "Director", ar: "مخرج" },
    image: "/team/sameh.jpeg",
  },
  {
    name: { en: "Coming Soon", ar: "قريباً" },
    role: { en: "New Member", ar: "عضو جديد" },
    image: "",
    placeholder: true,
  },
];

export const testimonials = [
  {
    quote: {
      en: "Today, during this visit, is the most wonderful day for me because I met a family I'm honored to be part of — people who make every gathering beautiful, because they're the ones who elevate it with their grace and magnificence. Thank you, my family. 🌹",
      ar: "اليوم يعتبر بالنسبة لي في هذه الزيارة هو الأروع لانني التقيت باسرة يشرفني ان اكون احد افرادها أوناس تحلو اللقاءات بوجودهم لانهم هم من يحلونها برقيهم وروعتهم شكراً اسرتي 🌹",
    },
    name: { en: "Haitham", ar: "هيثم" },
    org: { en: "Our clients", ar: "عملائنا" },
  },
  {
    quote: {
      en: "Blessed be the Merciful — such care for the youth, kind treatment, elegance and truly refined taste. Thank you for your wonderful efforts, and many thanks to Director Hani Hijazi for his gentleness and kindness with the young team, embracing them and bringing enthusiasm and positive spirit to the entire crew. May God grant you continued success.",
      ar: "تبارك الرحمن ..احتواء للشباب وحسن تعامل ورقي وذوق عالي جدا..مشكورين على مجهوداتكم الرائعه والشكر الجزيل للمخرج الأستاذ هاني حجازي على سماحته ولطافته مع الشباب وإحتوائهم  وإدخال الحماس والروح الإيجابيه بين فريق العمل ككل .. اللهم التوفيق فالكم وحليفكم ياكريم .",
    },
    name: { en: "Rasheen", ar: "رشين" },
    org: { en: "Our clients", ar: "عملائنا" },
  },
  {
    quote: {
      en: "Mashallah, the studio is truly outstanding — a training hall and a sound studio. It was an honor to visit Director Hani Hijazi.",
      ar: "ماشاء الله الاستديو رائع جدا ( قاعة للتدريب _استديو صوت ) تشرفت بزيارة المخرج الاستاذ هاني حجازي",
    },
    name: { en: "Ali Alkhathami", ar: "علي الخثعمي" },
    org: { en: "Our clients", ar: "عملائنا" },
  },
];

export const values = [
  {
    icon: "Sparkles",
    title: { en: "Creativity", ar: "الإبداع" },
    desc: { en: "Every frame is an argument for a specific creative point of view.", ar: "كل كادر هو حجّة لوجهة نظر إبداعية محدّدة." },
  },
  {
    icon: "Award",
    title: { en: "Quality", ar: "الجودة" },
    desc: { en: "Broadcast-grade, festival-grade, always.", ar: "بمعايير البث والمهرجانات دائماً." },
  },
  {
    icon: "Users",
    title: { en: "Collaboration", ar: "التعاون" },
    desc: { en: "Client-side is part of the crew, not the audience.", ar: "العميل جزء من الطاقم، لا من الجمهور." },
  },
  {
    icon: "Lightbulb",
    title: { en: "Innovation", ar: "الابتكار" },
    desc: {
      en: "Our innovation isn't technical — it's visual and cinematic. We renew the visual language through precise decisions, not through gimmicky tools.",
      ar: "ابتكارنا ليس تقنيًا — بل بصري وسينمائي. نجدد اللغة البصرية عبر قرارات دقيقة، لا عبر أدوات استعراضية.",
    },
  },
];

export const whyChoose = [
  {
    icon: "Feather",
    title: { en: "Cinematic Storytelling", ar: "سرد سينمائي" },
    desc: { en: "Story-first. We only greenlight ideas that carry a strong emotional through-line.", ar: "القصة أولاً. لا نعتمد فكرة إلا إذا كانت تحمل خيطاً عاطفياً قوياً." },
  },
  {
    icon: "ShieldCheck",
    title: { en: "Production Quality", ar: "جودة الإنتاج" },
    desc: { en: "Broadcast-grade craft: ARRI, RED and Sony Venice bodies, calibrated post pipeline.", ar: "جودة بث احترافية: كاميرات ARRI و RED و Sony Venice، وخط معالجة معاير." },
  },
  {
    icon: "Timer",
    title: { en: "Fast & Reliable Delivery", ar: "تسليم سريع وموثوق" },
    desc: { en: "In-house pre-vis, on-set data wrangling and a producer per project keep dates honest.", ar: "بريـفيز داخلي وإدارة بيانات في الموقع ومنتج مخصّص لكل مشروع." },
  },
  {
    icon: "Palette",
    title: { en: "Our work isn't translated — it's from our reality", ar: "أعمالنا ليست مترجمة — بل من واقعنا" },
    desc: {
      en: "We don't translate a style from one culture to another; we only channel what grows in our imagination, emotions, and culture. The result: work that doesn't just look cinematic — it feels inevitable, because it's made from our reality, not from someone else's.",
      ar: "لا نترجم أسلوبًا من بيئة إلى أخرى؛ نعتمد فقط ما ينمو في خيالنا، عواطفنا، وثقافتنا. النتيجة: أعمال لا تبدو سينمائية فحسب، بل تبدو حتمية، لأنها صُنعت من واقعنا، لا من ترجمة واقع غيره.",
    },
  },
];

export const clientLogos = [
  { name: "State Security Presidency", nameAr: "رئاسة أمن الدولة", image: "/clients/state-security.png" },
  { name: "ART Channel", nameAr: "قناة ART", image: "/clients/art-channel.png" },
  { name: "MBC Group", nameAr: "مجموعة MBC", image: "/clients/mbc-group.png" },
  { name: "Ministry of Health", nameAr: "وزارة الصحة", image: "/clients/ministry-of-health.png" },
  { name: "Al Jazeera Media Network", nameAr: "شبكة الجزيرة الإعلامية", image: "/clients/aljazeera.png" },
  { name: "Ikhaa Charitable Association", nameAr: "جمعية إخاء الخيرية", image: "/clients/ikhaa.png" },
];
